import React from "react";

const FollowUsOn = () => {
  return (
    <div className="follow_us_wrapper" id="wearAndCare">
      <div className="follow_us_container">
        <p className="follow_us_wrapper_heading">Also follow us on</p>

        <div className="followUS--icons">
          <a
            href="https://www.instagram.com/aqualens.in"
            target="_blank"
            rel="noopener"
          >
            <svg
              width="30"
              height="31"
              viewBox="0 0 30 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_471_2765)">
                <path
                  d="M22.3926 30.2963C23.553 30.2833 24.7025 30.0705 25.7906 29.6672C26.5852 29.3735 27.3041 28.9059 27.8947 28.2986C28.5036 27.7092 28.9719 26.9901 29.2647 26.1948C29.6677 25.1068 29.8802 23.9574 29.8929 22.7972C29.9821 20.8683 30 20.2898 30 15.4025C30 10.5151 29.9803 9.93864 29.8938 8.00835C29.8796 6.84858 29.6668 5.69981 29.2647 4.61188C28.9704 3.81717 28.5028 3.09799 27.8959 2.50658C27.306 1.89824 26.5867 1.43041 25.7915 1.13776C24.7034 0.734412 23.5539 0.521592 22.3935 0.508642C20.4641 0.420407 19.8847 0.402466 15 0.402466C10.1153 0.402466 9.53618 0.422172 7.60588 0.508642C6.44581 0.522784 5.29674 0.735567 4.20853 1.13776C3.41362 1.4308 2.69458 1.89846 2.10441 2.50629C1.4964 3.09666 1.02854 3.81588 0.735292 4.611C0.331844 5.69907 0.118925 6.84854 0.105881 8.00894C0.0176468 9.93923 -0.000295639 10.5172 -0.000295639 15.4031C-0.000295639 20.2889 0.0176468 20.8669 0.105881 22.7972C0.119886 23.9574 0.332775 25.1066 0.735292 26.1948C1.03977 26.984 1.50611 27.7007 2.1043 28.2987C2.7025 28.8967 3.41928 29.3629 4.20853 29.6672C5.29661 30.0706 6.44608 30.2835 7.60647 30.2966C9.535 30.3848 10.1147 30.4028 15.0006 30.4028C19.8865 30.4028 20.4644 30.3857 22.3929 30.2966"
                  fill="url(#paint0_radial_471_2765)"
                />
                <path
                  d="M22.3926 30.2963C23.553 30.2833 24.7025 30.0705 25.7906 29.6672C26.5852 29.3735 27.3041 28.9059 27.8947 28.2986C28.5036 27.7092 28.9719 26.9901 29.2647 26.1948C29.6677 25.1068 29.8802 23.9574 29.8929 22.7972C29.9821 20.8683 30 20.2898 30 15.4025C30 10.5151 29.9803 9.93864 29.8938 8.00835C29.8796 6.84858 29.6668 5.69981 29.2647 4.61188C28.9704 3.81717 28.5028 3.09799 27.8959 2.50658C27.306 1.89824 26.5867 1.43041 25.7915 1.13776C24.7034 0.734412 23.5539 0.521592 22.3935 0.508642C20.4641 0.420407 19.8847 0.402466 15 0.402466C10.1153 0.402466 9.53618 0.422172 7.60588 0.508642C6.44581 0.522784 5.29674 0.735567 4.20853 1.13776C3.41362 1.4308 2.69458 1.89846 2.10441 2.50629C1.4964 3.09666 1.02854 3.81588 0.735292 4.611C0.331844 5.69907 0.118925 6.84854 0.105881 8.00894C0.0176468 9.93923 -0.000295639 10.5172 -0.000295639 15.4031C-0.000295639 20.2889 0.0176468 20.8669 0.105881 22.7972C0.119886 23.9574 0.332775 25.1066 0.735292 26.1948C1.03977 26.984 1.50611 27.7007 2.1043 28.2987C2.7025 28.8967 3.41928 29.3629 4.20853 29.6672C5.29661 30.0706 6.44608 30.2835 7.60647 30.2966C9.535 30.3848 10.1147 30.4028 15.0006 30.4028C19.8865 30.4028 20.4644 30.3857 22.3929 30.2966"
                  fill="url(#paint1_radial_471_2765)"
                />
                <path
                  d="M18.6832 15.4663C18.6831 14.7315 18.4652 14.0133 18.0569 13.4024C17.6486 12.7915 17.0684 12.3154 16.3895 12.0342C15.7106 11.7531 14.9637 11.6796 14.243 11.8231C13.5224 11.9665 12.8605 12.3204 12.341 12.84C11.8215 13.3596 11.4677 14.0216 11.3245 14.7423C11.1812 15.463 11.2549 16.21 11.5362 16.8888C11.8174 17.5676 12.2937 18.1477 12.9047 18.5558C13.5157 18.9639 14.234 19.1817 14.9688 19.1816C15.954 19.1815 16.8988 18.7899 17.5954 18.0932C18.292 17.3964 18.6833 16.4515 18.6832 15.4663ZM20.6917 15.4663C20.6917 16.5982 20.3561 17.7047 19.7272 18.6458C19.0984 19.5869 18.2046 20.3205 17.1588 20.7536C16.1131 21.1868 14.9624 21.3001 13.8523 21.0793C12.7421 20.8585 11.7224 20.3134 10.922 19.513C10.1217 18.7127 9.57662 17.6929 9.35579 16.5828C9.13497 15.4727 9.24831 14.322 9.68146 13.2762C10.1146 12.2305 10.8481 11.3367 11.7893 10.7079C12.7304 10.079 13.8369 9.74337 14.9688 9.74337C15.7203 9.74333 16.4645 9.89133 17.1589 10.1789C17.8532 10.4665 18.4842 10.8881 19.0156 11.4195C19.547 11.9509 19.9686 12.5818 20.2562 13.2762C20.5437 13.9705 20.6918 14.7148 20.6917 15.4663ZM10.3567 9.5166C10.3568 9.78111 10.2785 10.0397 10.1316 10.2597C9.9848 10.4797 9.77601 10.6512 9.53168 10.7525C9.28736 10.8538 9.01848 10.8805 8.75903 10.829C8.49959 10.7775 8.26123 10.6502 8.07412 10.4633C7.887 10.2763 7.75953 10.0381 7.70782 9.77868C7.6561 9.51928 7.68247 9.25037 7.78358 9.00595C7.8847 8.76154 8.05602 8.5526 8.27588 8.40556C8.49574 8.25851 8.75427 8.17996 9.01877 8.17984C9.37331 8.18 9.71329 8.32087 9.96405 8.57151C10.2148 8.82215 10.3558 9.16206 10.3561 9.5166M19.4708 24.5384C20.1776 24.5306 20.8777 24.4013 21.5405 24.156C22.0213 23.9707 22.4578 23.6868 22.8222 23.3226C23.1866 22.9584 23.4706 22.5219 23.6561 22.0413C23.9015 21.3785 24.0308 20.6783 24.0385 19.9716C24.0926 18.7969 24.1032 18.444 24.1032 15.4678C24.1032 12.4916 24.0914 12.1395 24.0385 10.9637C24.0299 10.257 23.9006 9.55703 23.6561 8.89395C23.4709 8.41309 23.1869 7.97639 22.8225 7.61201C22.4581 7.24762 22.0214 6.96364 21.5405 6.77837C20.8777 6.53301 20.1776 6.40367 19.4708 6.39602C18.2961 6.3419 17.9432 6.33131 14.9682 6.33131C11.9932 6.33131 11.6399 6.34278 10.4641 6.39631C9.75742 6.40489 9.05743 6.5342 8.39436 6.77866C7.9135 6.96395 7.47681 7.24794 7.11243 7.61232C6.74805 7.97671 6.46406 8.4134 6.27877 8.89425C6.03343 9.55708 5.90409 10.2572 5.89642 10.964C5.8423 12.1404 5.83171 12.4916 5.83171 15.4681C5.83171 18.4445 5.8426 18.7963 5.89642 19.9722C5.90465 20.6789 6.03397 21.3789 6.27877 22.0419C6.46426 22.5225 6.74832 22.959 7.11269 23.3232C7.47706 23.6874 7.91364 23.9713 8.39436 24.1566C9.05719 24.402 9.75733 24.5313 10.4641 24.539C11.6388 24.5931 11.9917 24.6037 14.9682 24.6037C17.9447 24.6037 18.2964 24.5928 19.4708 24.539M19.5632 4.38925C20.4879 4.40744 21.4029 4.58246 22.2691 4.90689C23.0095 5.19318 23.682 5.63103 24.2433 6.19238C24.8046 6.75372 25.2425 7.42616 25.5288 8.1666C25.8532 9.03278 26.0282 9.94774 26.0464 10.8725C26.1014 12.0607 26.1138 12.4407 26.1138 15.4675C26.1138 18.4943 26.1011 18.874 26.0464 20.0625C26.0282 20.9872 25.8532 21.9022 25.5288 22.7684C25.2425 23.5088 24.8046 24.1812 24.2433 24.7426C23.6819 25.3039 23.0095 25.7418 22.2691 26.0281C21.4029 26.3524 20.4879 26.5274 19.5632 26.5457C18.3744 26.5998 17.9949 26.6131 14.9682 26.6131C11.9414 26.6131 11.5617 26.6004 10.3732 26.5457C9.44843 26.5275 8.53349 26.3524 7.6673 26.0281C6.92687 25.7418 6.25443 25.3039 5.69309 24.7426C5.13175 24.1812 4.6939 23.5088 4.40759 22.7684C4.08278 21.9023 3.90773 20.9873 3.88994 20.0625C3.83583 18.8734 3.82348 18.4943 3.82348 15.4675C3.82348 12.4407 3.83612 12.061 3.88994 10.8725C3.90812 9.94773 4.08316 9.03277 4.40759 8.1666C4.69388 7.4263 5.13162 6.75396 5.6928 6.19264C6.25397 5.63131 6.92619 5.19338 7.66641 4.90689C8.53252 4.58226 9.44752 4.40722 10.3723 4.38925C11.5608 4.33484 11.9405 4.3219 14.9667 4.3219C17.9929 4.3219 18.3735 4.33455 19.5626 4.38925"
                  fill="white"
                />
              </g>
              <defs>
                <radialGradient
                  id="paint0_radial_471_2765"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(28.0585 29.7454) rotate(180) scale(38.0888)"
                >
                  <stop offset="0.09" stop-color="#FA8F21" />
                  <stop offset="0.78" stop-color="#D82D7E" />
                </radialGradient>
                <radialGradient
                  id="paint1_radial_471_2765"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(9.22 28.7819) rotate(180) scale(33.5185)"
                >
                  <stop offset="0.64" stop-color="#8C3AAA" stop-opacity="0" />
                  <stop offset="1" stop-color="#8C3AAA" />
                </radialGradient>
                <clipPath id="clip0_471_2765">
                  <rect
                    width="30"
                    height="30"
                    fill="white"
                    transform="matrix(-1 0 0 1 30 0.402466)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a
            href="https://www.facebook.com/aqualens/"
            target="_blank"
            rel="noopener"
          >
            <svg
              width="30"
              height="31"
              viewBox="0 0 30 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_471_2769)">
                <path
                  d="M26.25 0.402466H3.75C1.68187 0.402466 0 2.08434 0 4.15247V26.6525C0 28.7206 1.68187 30.4025 3.75 30.4025H26.25C28.3181 30.4025 30 28.7206 30 26.6525V4.15247C30 2.08434 28.3181 0.402466 26.25 0.402466Z"
                  fill="#1976D2"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M25.3125 15.4025H20.625V11.6525C20.625 10.6175 21.465 10.715 22.5 10.715H24.375V6.02747H20.625C19.1332 6.02747 17.7024 6.6201 16.6475 7.67499C15.5926 8.72988 15 10.1606 15 11.6525V15.4025H11.25V20.09H15V30.4025H20.625V20.09H23.4375L25.3125 15.4025Z"
                  fill="#FAFAFA"
                />
              </g>
              <defs>
                <clipPath id="clip0_471_2769">
                  <rect
                    width="30"
                    height="30"
                    fill="white"
                    transform="translate(0 0.402466)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a
            href="https://www.youtube.com/channel/UCJowRweHgj1l_jfDfHt5K6g"
            target="_blank"
            rel="noopener"
          >
            <svg
              width="30"
              height="31"
              viewBox="0 0 30 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_471_2772)">
                <path
                  d="M23.2664 0.402466H6.73363C3.01475 0.402466 0 3.41722 0 7.1361V23.6688C0 27.3877 3.01475 30.4025 6.73363 30.4025H23.2664C26.9852 30.4025 30 27.3877 30 23.6688V7.1361C30 3.41722 26.9852 0.402466 23.2664 0.402466Z"
                  fill="#FD3832"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.31309 20.9463C8.01322 20.8554 7.73961 20.6937 7.51534 20.4749C7.29108 20.2561 7.12275 19.9865 7.02455 19.6889C6.46342 18.151 6.29715 11.7291 7.37786 10.4614C7.73754 10.049 8.24536 9.79505 8.79109 9.75475C11.6903 9.44301 20.6477 9.48457 21.6764 9.85867C21.9658 9.95254 22.2301 10.1107 22.4497 10.3212C22.6692 10.5318 22.8383 10.7893 22.9442 11.0745C23.5573 12.6643 23.5781 18.442 22.8611 19.9695C22.6709 20.3671 22.3524 20.6892 21.957 20.8839C20.8763 21.4243 9.7471 21.4139 8.31309 20.9463ZM12.9165 17.9328L18.1122 15.231L12.9165 12.5085V17.9328Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_471_2772">
                  <rect
                    width="30"
                    height="30"
                    fill="white"
                    transform="translate(0 0.402466)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a
            href="https://twitter.com/aqualens_in?lang=en"
            target="_blank"
            rel="noopener"
          >
            <svg
              width="30"
              height="31"
              viewBox="0 0 30 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_471_2777)">
                <path
                  d="M23.6019 0.402466H6.39813C2.86454 0.402466 0 3.267 0 6.80059V24.0043C0 27.5379 2.86454 30.4025 6.39813 30.4025H23.6019C27.1355 30.4025 30 27.5379 30 24.0043V6.80059C30 3.267 27.1355 0.402466 23.6019 0.402466Z"
                  fill="#0A93E2"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M24.1249 10.8522C23.4671 11.1434 22.7695 11.3344 22.0551 11.419C22.8022 10.9708 23.3734 10.2633 23.6371 9.42402C22.9305 9.84285 22.1578 10.1385 21.3521 10.2985C20.8583 9.7685 20.2164 9.39959 19.5099 9.23991C18.8034 9.08022 18.0651 9.13716 17.3915 9.4033C16.7178 9.66945 16.14 10.1324 15.7334 10.7319C15.3268 11.3313 15.1103 12.0394 15.1121 12.7637C15.1113 13.0403 15.1422 13.316 15.2044 13.5854C13.7711 13.5136 12.3688 13.1412 11.0887 12.4924C9.80856 11.8436 8.67911 10.933 7.77362 9.81951C7.31043 10.6132 7.168 11.5539 7.37548 12.4492C7.58296 13.3445 8.12466 14.1266 8.88978 14.6357C8.31653 14.6177 7.75595 14.4625 7.25509 14.1831V14.227C7.25509 15.976 8.49868 17.4349 10.1466 17.7644C9.61644 17.9091 9.06019 17.9301 8.52066 17.826C8.75109 18.5419 9.1993 19.1681 9.80272 19.6172C10.4061 20.0662 11.1347 20.3156 11.8867 20.3307C11.1387 20.9186 10.2822 21.3532 9.36599 21.6096C8.44982 21.866 7.49208 21.9391 6.54761 21.8248C8.14274 22.8487 10.0367 23.4419 12.0757 23.4419C18.7111 23.4419 22.3364 17.949 22.3364 13.1812C22.3364 13.0274 22.3364 12.8736 22.3276 12.7154C23.0307 12.21 23.6459 11.5728 24.1293 10.8522H24.1249Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_471_2777">
                  <rect
                    width="30"
                    height="30"
                    fill="white"
                    transform="translate(0 0.402466)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default FollowUsOn;
